export const MINIMAL_HEADER_HEIGHT = 60;

export const MINIMAL_HEADER_HEIGHT_MOBILE = 50;

export const SMALL_LOGO_WIDTH = 320;

export const MAX_HEADER_WIDTH = 1920;

export const CRAFT_BLOG_PATH = "https://craft.faire.com/";
